import { adminInstance } from "@/api/instance";

export default async function (counselId) {
  return adminInstance.patch(`/counsel/${counselId}`);
}
